import React, { useRef } from 'react';
import { Row, Col, Card, FormGroup, Label, Input, Button, CardBody, CardHeader } from 'reactstrap';
import { useReportShippingDownloads } from '../../../hooks/Pbi/useReportShippingDownloads';
import "../../admission/Bi/styleReportShippingDownload.css"
import { ToastAletGlobal } from '../../alertDialog/ToastAletGlobal';

export const IndexReportShippingDownloads = () => {
    const tableContainerRef = useRef(null);

    const {
          //? FORM
        mDateRange1,
        mDateRange2,
        mActionType,
        handleInputChange,

        //? REPORT
        filteredLogs,
        paginatedLogs,
        loading,

        //? INDICATORS
        indicators,

        //? SEARCH
        searchTerm,
        handleSearch,

        //? FILTERS
        getReportLogs,
        handleClean,
        tableFilters,
        handleTableFilter,
        clearTableFilters,
        appliedActionType,

        //? PAGINATION
        currentPage,
        totalPages,
        rowsPerPage,
        handleChangePage,
        handleRowsPerPage,

        //? EXCEL
        exportExcel,
        
        //? TOAST ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert,
    } = useReportShippingDownloads();

    const changePage = (page) => {
        handleChangePage(page);

        if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop = 0;
        }
    };

    return (
        <>
        <div className='container-global-zoom' style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Card style={{
                marginBottom: "15px",
                background: "linear-gradient(135deg, #002940 0%, #1d5b83 100%)",
                border: "none",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
            }}>
                <CardBody style={{ padding: "10px 25px" }}>
                    <div className="d-flex align-items-center">
                        <img
                            alt="flask"
                            src={require("../../../assets/images/laboratory-External/mail.svg")}
                            style={{ width: "60px", height: "60px", marginRight: "15px" }}
                        />

                        <div style={{ textAlign: "left" }}>
                            <h4 className="mb-1" style={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
                                Reporte de control de envíos e impresiones
                            </h4>

                            <small style={{ color: "rgba(255,255,255,0.85)", fontSize: "13px" }}>
                                <i className="fa fa-info-circle mr-1"></i>
                                Consulta de impresiones y envíos de resultados realizados por NIM.
                            </small>
                        </div>
                    </div>
                </CardBody>
            </Card>

            <Card className="shadow-sm border height-equal pricingtable mb-0 pb-0" style={{ padding: "5px", width: "100%" }}>
                <Col sm="12">
                    <Row className="mb-3 report-kpi-row">
                        <Col sm="4">
                            <div className="report-kpi report-kpi-blue">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Impreso
                                    </div>

                                    <div className="report-kpi-number">
                                        {indicators.total_printed}
                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-file-text-o"></i>
                                        Resultados impresos
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-print"></i>
                                </div>
                            </div>
                        </Col>

                        <Col sm="4">
                            <div className="report-kpi report-kpi-green">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Correo electrónico
                                    </div>

                                    <div className="report-kpi-number">
                                        {indicators.total_sent}
                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-check-circle-o"></i>
                                        Resultados enviados
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-paper-plane"></i>
                                </div>
                            </div>
                        </Col>

                        <Col sm="4">
                            <div className="report-kpi report-kpi-orange">
                                <div className="report-kpi-decoration"></div>
                                <div className="report-kpi-info">
                                    <div className="report-kpi-title">
                                        <span className="report-kpi-dot"></span>
                                        Total de movimientos
                                    </div>

                                    <div className="report-kpi-number">
                                        {indicators.total_actions}
                                    </div>

                                    <div className="report-kpi-footer">
                                        <i className="fa fa-line-chart"></i>
                                        Movimientos registrados
                                    </div>
                                </div>

                                <div className="report-kpi-icon">
                                    <i className="fa fa-list-alt"></i>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>

                <Col sm="12" className="pt-3">
                    <Row>
                        <Col sm="2" className="p-l-0 p-r-0" style={{ textAlign: "left" }}>
                            <Card style={{
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                border: "none",
                                borderRadius: "12px"
                            }}>
                                <CardHeader style={{
                                    background: "linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)",
                                    color: "white",
                                    padding: "15px",
                                    borderRadius: "12px 12px 0 0"
                                }}>
                                    <h6 className="mb-0" style={{ fontWeight: 700, fontSize: "15px" }}>
                                        <i className="fa fa-filter mr-2"></i>
                                        Filtros de búsqueda
                                    </h6>
                                </CardHeader>

                                <CardBody style={{ padding: "18px" }}>

                                    <FormGroup>
                                        <Label className="f-w-600 label-report">
                                            <i className="fa fa-calendar mr-2" style={{ color: "#1d5b83" }}></i>
                                            Fecha de inicio
                                        </Label>

                                        <Input
                                            type="date"
                                            value={mDateRange1}
                                            name="mDateRange1"
                                            onChange={handleInputChange}
                                            style={{ borderRadius: "8px", fontSize: "12px" }}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label className="f-w-600 label-report">
                                            <i className="fa fa-calendar-check mr-2" style={{ color: "#28a745" }}></i>
                                            Fecha de cierre
                                        </Label>

                                        <Input
                                            type="date"
                                            value={mDateRange2}
                                            name="mDateRange2"
                                            onChange={handleInputChange}
                                            style={{ borderRadius: "8px", fontSize: "12px" }}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label className="f-w-600 label-report">
                                            <i className="fa fa-tasks mr-2" style={{ color: "#1d5b83" }}></i>
                                            Método de entrega
                                        </Label>

                                        <Input
                                            type="select"
                                            name="mActionType"
                                            value={mActionType}
                                            onChange={handleInputChange}
                                            style={{ borderRadius: "8px", fontSize: "13px" }}
                                        >
                                            <option value="">Todos</option>
                                            <option value="3">Impresión</option>
                                            <option value="2">Correo electrónico</option>
                                        </Input>
                                    </FormGroup>

                                    <br />
                                    <b>Acciones</b>
                                    <br /><br />

                                    <Button
                                        onClick={getReportLogs}
                                        disabled={loading}
                                        color="primary"
                                        block
                                        outline
                                        className="mb-2"
                                        style={{ borderRadius: "10px", padding: "6px", fontSize: "13px", fontWeight: 600 }}
                                    >
                                        Buscar
                                    </Button>

                                    <Button
                                        onClick={handleClean}
                                        disabled={loading}
                                        color="danger"
                                        block
                                        outline
                                        className="mb-2"
                                        style={{ borderRadius: "10px", padding: "6px", fontSize: "13px", fontWeight: 600 }}
                                    >
                                        <i className="fa fa-eraser mr-2"></i>
                                        Limpiar
                                    </Button>

                                    <Button
                                        color="success"
                                        onClick={exportExcel}
                                        disabled={filteredLogs.length === 0}
                                        block
                                        style={{ borderRadius: "10px", padding: "6px", fontSize: "13px", fontWeight: 600 }}
                                    >
                                        <i className="pi pi-file-excel"></i>&ensp;
                                        Descargar
                                    </Button>

                                </CardBody>
                            </Card>
                        </Col>

                       <Col sm="10">
                            <div className="report-table-card">
                                <div className="report-table-toolbar">
                                    <div className="report-table-title">
                                        <div className="report-table-title-icon">
                                            <i className="fa fa-list-ul"></i>
                                        </div>

                                        <div>
                                            <h5>Detalle de movimientos</h5>
                                        </div>
                                    </div>

                                    <div className="report-table-actions">
                                        <div className="report-general-search">
                                            <i className="pi pi-search"></i>

                                            <Input
                                                type="search"
                                                placeholder="Buscar en todos los registros..."
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />

                                            {searchTerm !== "" && (
                                                <button
                                                    type="button"
                                                    onClick={clearTableFilters}
                                                    className="report-search-clear"
                                                >
                                                    <i className="fa fa-times"></i>
                                                </button>
                                            )}
                                        </div>

                                        <button
                                            type="button"
                                            className="report-clear-filters"
                                            onClick={clearTableFilters}
                                            title="Limpiar filtros de tabla"
                                        >
                                            <i className="fa fa-filter"></i>
                                            <span>Limpiar</span>
                                        </button>
                                    </div>
                                </div>

                                <div ref={tableContainerRef} className="report-table-container">
                                    <table className="report-movements-table">
                                        <thead>

                                            {/* ENCABEZADOS */}
                                            <tr className="report-main-header">
                                                <th className="column-number">#</th>
                                                <th>NIM</th>
                                                <th>
                                                    {tableFilters.patient_type === "COMPANY"
                                                        ? "Empresa"
                                                        : tableFilters.patient_type === "PATIENT"
                                                            ? "Paciente"
                                                            : "Paciente / Empresa"}
                                                </th>
                                                <th>Método de entrega</th>
                                                <th>Correo</th>
                                                <th>Fecha</th>
                                                <th>Usuario</th>
                                                <th className="text-center">Impresiones</th>
                                                <th className="text-center">Correo</th>
                                                <th className="text-center">Total</th>
                                                
                                            </tr>

                                            {/* FILTERS */}
                                            <tr className="report-filter-row">
                                                <th></th>
                                                <th>
                                                    <div className="report-column-filter">
                                                        <i className="pi pi-search"></i>

                                                        <input
                                                            type="text"
                                                            name="nim"
                                                            value={tableFilters.nim}
                                                            onChange={handleTableFilter}
                                                            placeholder="Filtrar NIM"
                                                        />
                                                    </div>
                                                </th>

                                                <th>
                                                    <div className="report-patient-filters">

                                                        <select
                                                            name="patient_type"
                                                            value={tableFilters.patient_type}
                                                            onChange={handleTableFilter}
                                                            className="report-patient-type-filter"
                                                        >
                                                            <option value="">Todos</option>
                                                            <option value="PATIENT">Pacientes</option>
                                                            <option value="COMPANY">Empresas</option>
                                                        </select>

                                                        <div className="report-column-filter">
                                                            <i
                                                                className={
                                                                    tableFilters.patient_type === "COMPANY"
                                                                        ? "fa fa-building"
                                                                        : "fa fa-user"
                                                                }
                                                            ></i>

                                                            <input
                                                                type="text"
                                                                name="patient"
                                                                value={tableFilters.patient}
                                                                onChange={handleTableFilter}
                                                                placeholder={
                                                                    tableFilters.patient_type === "COMPANY"
                                                                        ? "Filtrar empresa"
                                                                        : tableFilters.patient_type === "PATIENT"
                                                                            ? "Filtrar paciente"
                                                                            : "Paciente / empresa"
                                                                }
                                                            />
                                                        </div>

                                                    </div>
                                                </th>

                                                <th>
                                                    {!appliedActionType && (
                                                        <select
                                                            name="action"
                                                            value={tableFilters.action}
                                                            onChange={handleTableFilter}
                                                            className="report-action-filter"
                                                        >
                                                            <option value="">Todas</option>
                                                            <option value="IMPRESIÓN">Impresión</option>
                                                            <option value="ENVÍO">Correo electrónico</option>
                                                        </select>
                                                    )}
                                                </th>

                                                <th>
                                                    <div className="report-column-filter">
                                                        <i className="fa fa-envelope-o"></i>
                                                        <input
                                                            type="text"
                                                            name="email"
                                                            value={tableFilters.email}
                                                            onChange={handleTableFilter}
                                                            placeholder="Correo"
                                                        />
                                                    </div>
                                                </th>

                                                <th>
                                                    <div className="report-column-filter">
                                                        <i className="fa fa-calendar"></i>
                                                        <input
                                                            type="text"
                                                            name="date"
                                                            value={tableFilters.date}
                                                            onChange={handleTableFilter}
                                                            placeholder="Fecha"
                                                        />
                                                    </div>
                                                </th>

                                                <th>
                                                    <div className="report-column-filter">
                                                        <i className="fa fa-user"></i>
                                                        <input
                                                            type="text"
                                                            name="user"
                                                            value={tableFilters.user}
                                                            onChange={handleTableFilter}
                                                            placeholder="Usuario"
                                                        />
                                                    </div>
                                                </th>

                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {loading && (
                                                <tr>
                                                    <td colSpan="10">
                                                        <div className="report-table-loading">
                                                            <div className="report-loader">
                                                                <i className="fa fa-spinner fa-spin"></i>
                                                            </div>

                                                            <span style={{fontSize:  "15px"}}>Consultando información...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}

                                            {!loading && paginatedLogs.length === 0 && (
                                                <tr>
                                                    <td colSpan="10">
                                                        <div className="report-table-empty">

                                                            <div className="report-empty-icon">
                                                                <i className="pi pi-search"></i>
                                                            </div>

                                                            <b>No encontramos movimientos</b>

                                                            <span>
                                                                Intenta cambiar los filtros de búsqueda.
                                                            </span>

                                                        </div>
                                                    </td>
                                                </tr>
                                            )}

                                            {!loading && paginatedLogs.map((row, rowIndex) => {
                                                const history = Array.isArray(row.history) ? row.history : [];
                                                const rowSpan = history.length || 1;
                                                const number = ((currentPage - 1) * rowsPerPage) + rowIndex +1;

                                                if (history.length === 0) {
                                                    return (
                                                        <tr key={row.id_work_order} className="report-nim-start">
                                                            <td className="report-number-cell">
                                                                {number}
                                                            </td>

                                                            <td>
                                                                <span className="report-nim">
                                                                    {row.nim}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <div className="report-patient">
                                                                    {row.patient}
                                                                </div>
                                                            </td>

                                                            <td className="text-center">
                                                                <span className="report-counter report-counter-print">
                                                                    <i className="fa fa-print"></i>
                                                                    {row.total_printed}
                                                                </span>
                                                            </td>

                                                            <td className="text-center">
                                                                <span className="report-counter report-counter-send">
                                                                    <i className="fa fa-paper-plane"></i>
                                                                    {row.total_sent}
                                                                </span>
                                                            </td>

                                                            <td className="text-center">
                                                                <span className="report-total">
                                                                    {row.total_actions}
                                                                </span>
                                                            </td>

                                                            <td>-</td>
                                                            <td>-</td>
                                                            <td>-</td>
                                                            <td>-</td>

                                                        </tr>
                                                    );
                                                }

                                                return history.map((item, historyIndex) => {
                                                    const first = historyIndex === 0;
                                                    const dateParts = item.date ? item.date.split(" ") : ["-", ""];
                                                    return (

                                                        <tr key={item.id_historical} className={first ? "report-nim-start" : "report-history-row"}>
                                                            {first && (
                                                                <td rowSpan={rowSpan} className="report-group-cell report-number-cell">
                                                                    {number}
                                                                </td>
                                                            )}

                                                            {first && (
                                                                <td rowSpan={rowSpan} className="report-group-cell">
                                                                    <div className="report-nim-wrapper">
                                                                        <span className="report-nim-icon">
                                                                            <i className="fa fa-hashtag"></i>
                                                                        </span>

                                                                        <span className="report-nim">
                                                                            {row.nim}
                                                                        </span>

                                                                    </div>
                                                                </td>
                                                            )}

                                                            {first && (
                                                                <td rowSpan={rowSpan} className="report-group-cell">
                                                                    <div className="report-patient">

                                                                        <div
                                                                            className={`report-patient-avatar ${
                                                                                row.patient_type === "COMPANY"
                                                                                    ? "report-company-avatar"
                                                                                    : "report-patient-avatar-person"
                                                                            }`}
                                                                        >
                                                                            <i
                                                                                className={
                                                                                    row.patient_type === "COMPANY"
                                                                                        ? "fa fa-building"
                                                                                        : "fa fa-user"
                                                                                }
                                                                            ></i>
                                                                        </div>

                                                                        <span
                                                                            className={
                                                                                row.patient_type === "COMPANY"
                                                                                    ? "report-company-name"
                                                                                    : "report-patient-name"
                                                                            }
                                                                        >
                                                                            {row.patient}
                                                                        </span>

                                                                    </div>
                                                                </td>
                                                            )}

                                                            <td className="report-history-cell text-center">
                                                                {item.action === "Impresión" ? (

                                                                    <span className="report-action report-action-print">
                                                                        <i className="fa fa-print"></i>
                                                                        Impresión
                                                                    </span>

                                                                ) : (

                                                                    <span className="report-action report-action-send">
                                                                        <i className="fa fa-paper-plane"></i>
                                                                        Correo electrónico
                                                                    </span>

                                                                )}
                                                            </td>

                                                            {/* CORREO */}
                                                            <td className="report-history-cell">
                                                                {item.email_sent_to ? (
                                                                    <div className="report-email">
                                                                        {/* <i className="fa fa-envelope-o"></i> */}

                                                                        <span>
                                                                            {item.email_sent_to}
                                                                        </span>
                                                                    </div>
                                                                ) : (
                                                                    <span className="report-no-email">
                                                                        —
                                                                    </span>
                                                                )}
                                                            </td>

                                                            {/* FECHA */}
                                                            <td className="report-history-cell">
                                                                <div className="report-date">
                                                                    <span>
                                                                        {dateParts[0]}
                                                                    </span>

                                                                    <small>
                                                                        <i className="fa fa-clock-o"></i>
                                                                        {dateParts[1]}
                                                                    </small>
                                                                </div>
                                                            </td>

                                                            {/* USUARIO */}
                                                            <td className="report-history-cell">
                                                                <div className="report-user">
                                                                    <div className="report-user-avatar">
                                                                        {item.user
                                                                            ? item.user.charAt(0)
                                                                            : "U"}
                                                                    </div>

                                                                    <span>
                                                                        {item.user}
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            {first && (
                                                                <td rowSpan={rowSpan} className="report-group-cell text-center">
                                                                    <span className="report-counter report-counter-print">
                                                                        <i className="fa fa-print"></i>
                                                                        {row.total_printed}
                                                                    </span>
                                                                </td>
                                                            )}

                                                            {first && (
                                                                <td rowSpan={rowSpan} className="report-group-cell text-center">
                                                                    <span className="report-counter report-counter-send">
                                                                        <i className="fa fa-paper-plane"></i>
                                                                        {row.total_sent}
                                                                    </span>
                                                                </td>
                                                            )}

                                                            {first && (
                                                                <td rowSpan={rowSpan} className="report-group-cell text-center">
                                                                    <span className="report-total">
                                                                        {row.total_actions}
                                                                    </span>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    );

                                                });

                                            })}

                                        </tbody>
                                    </table>
                                </div>

                                {/* PAGINACIÓN */}
                                {!loading && filteredLogs.length > 0 && (
                                    <div className="report-pagination">
                                        <div className="report-pagination-size">
                                            <span>Mostrar</span>
                                            <Input
                                                type="select"
                                                value={rowsPerPage}
                                                onChange={handleRowsPerPage}
                                            >
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                            </Input>

                                            <span>NIM por página</span>
                                        </div>

                                        <div className="report-pagination-info">
                                            <span>
                                                <b>{filteredLogs.length}</b> NIM encontrados
                                            </span>
                                        </div>

                                        <div className="report-pagination-controls">
                                            <Button
                                                size="sm"
                                                disabled={currentPage === 1}
                                                onClick={() => changePage(currentPage - 1)}
                                            >
                                                <i className="fa fa-chevron-left"></i>
                                            </Button>

                                            <div>
                                                Página
                                                <strong>{currentPage}</strong>
                                                de
                                                <strong>{totalPages}</strong>
                                            </div>

                                            <Button
                                                size="sm"
                                                disabled={currentPage === totalPages}
                                                onClick={() => changePage(currentPage + 1)}
                                            >
                                                <i className="fa fa-chevron-right"></i>
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Card>
            <br /><br /> <br /><br />
        </div>

        <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />
        </>
        
    );
};